module.exports = "fonts/DejaVuSansMono.woff";